import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProfileComponent} from "./profile/profile.component";
import {AdminLayoutComponent} from "../../shared/components/layout/admin-layout/admin-layout.component";
import {UserEventComponent} from "./user-event/user-event.component";
import {EventContactComponent} from "./event-contact/event-contact.component";
import {EventManagementComponent} from "./profile/event-management/event-management.component";
import {AuthGuardTsGuard} from "../../guard/auth-guard.ts.guard";

const routes: Routes = [

  //base routing
  {
    path: 'perfil', component: AdminLayoutComponent, children: [
      {path: '', component: ProfileComponent},
      {path: 'gestao-ocorrencias', component: EventManagementComponent},
      {path: 'ocorrencias', component: UserEventComponent},
      {path: 'pedidos-contacto', component: EventContactComponent},
    ],
    canActivate: [AuthGuardTsGuard],
    canActivateChild: [AuthGuardTsGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {
}
